// src/odoo/customers/hooks/useCustomerDocuments.ts
// All comments are in English.

import { useQuery } from "@tanstack/react-query";

import {
  fetchDocuments,
  type DocumentsResponse,
  type DocumentsQueryParams,
} from "../api/documentsApi";

// Root query key for all customer-related queries.
export const CUSTOMERS_QUERY_KEY = "customers";

/**
 * Sales orders and invoices for a company-level customer.
 * Intended to power a dedicated "Sales & Invoices" tab
 * similar to the overview tab.
 */
export function useCustomerDocuments(
  companyPartnerId?: number,
  params?: DocumentsQueryParams
) {
  return useQuery<DocumentsResponse>({
    queryKey: [
      CUSTOMERS_QUERY_KEY,
      "documents",
      companyPartnerId,
      params ?? null,
    ],
    queryFn: () => fetchDocuments(companyPartnerId as number, params),
    enabled: !!companyPartnerId,
  });
}
